import { getGridSummaryCount, renderGridSummarySum, renderGridSummarySumTonnes, renderGridSummarySumHL } from 'components/global/utils';
import { MainReportGridData } from '@pages/reporting-pages/deliveries-main/types/MainReportGridData';



interface GridSummaryProps<T> {
	data?: T[] | null,
	isSubtotal?: boolean,
	label?: string,
}


const GridSummary = (props: GridSummaryProps<MainReportGridData>) => {
	const { data, isSubtotal = false, label } = props;

	return (
		<>
			<div className={`app-grid-summary${isSubtotal ? ' small-grid-summary' : ''}`}>
				{label ? label : ''}
			</div>

			<div className={`app-grid-summary left-align-cell${isSubtotal ? ' small-grid-summary' : ''}`}>
				<p>{getGridSummaryCount(data)}</p>
			</div>


			<div className={`app-grid-summary right-align-cell${isSubtotal ? ' small-grid-summary' : ''}`}>
				<p>{renderGridSummarySumHL(data, 'sd_volume')}</p>
			</div>

			<div className={`app-grid-summary right-align-cell${isSubtotal ? ' small-grid-summary' : ''}`}>
				<p>{renderGridSummarySumTonnes(data, 'sd_weight')}</p>
			</div>

			<div className={`app-grid-summary right-align-cell${isSubtotal ? ' small-grid-summary' : ''}`}>
				<p>{renderGridSummarySumTonnes(data, 'sd_returnsWeight')}</p>
			</div>

			<div className={`app-grid-summary right-align-cell${isSubtotal ? ' small-grid-summary' : ''}`}>
				<p>{renderGridSummarySum(data, 'sd_ordersCount')}</p>
			</div>


			<div className={`app-grid-summary right-align-cell${isSubtotal ? ' small-grid-summary' : ''}`}>
				<p>{renderGridSummarySumHL(data, 'int_volume')}</p>
			</div>

			<div className={`app-grid-summary right-align-cell${isSubtotal ? ' small-grid-summary' : ''}`}>
				<p>{renderGridSummarySumTonnes(data, 'int_weight')}</p>
			</div>

			<div className={`app-grid-summary right-align-cell${isSubtotal ? ' small-grid-summary' : ''}`}>
				<p>{renderGridSummarySumTonnes(data, 'int_returnsWeight')}</p>
			</div>

			<div className={`app-grid-summary right-align-cell${isSubtotal ? ' small-grid-summary' : ''}`}>
				<p>{renderGridSummarySum(data, 'int_ordersCount')}</p>
			</div>


			<div className={`app-grid-summary right-align-cell${isSubtotal ? ' small-grid-summary' : ''}`}>
				<p>{renderGridSummarySumHL(data, 'dd_volume')}</p>
			</div>

			<div className={`app-grid-summary right-align-cell${isSubtotal ? ' small-grid-summary' : ''}`}>
				<p>{renderGridSummarySumTonnes(data, 'dd_weight')}</p>
			</div>

			<div className={`app-grid-summary right-align-cell${isSubtotal ? ' small-grid-summary' : ''}`}>
				<p>{renderGridSummarySumTonnes(data, 'dd_returnsWeight')}</p>
			</div>

			<div className={`app-grid-summary right-align-cell${isSubtotal ? ' small-grid-summary' : ''}`}>
				<p>{renderGridSummarySum(data, 'dd_ordersCount')}</p>
			</div>


			<div className={`app-grid-summary right-align-cell${isSubtotal ? ' small-grid-summary' : ''}`}>
				<p>{renderGridSummarySumHL(data, 'td_volume')}</p>
			</div>

			<div className={`app-grid-summary right-align-cell${isSubtotal ? ' small-grid-summary' : ''}`}>
				<p>{renderGridSummarySumTonnes(data, 'td_weight')}</p>
			</div>

			<div className={`app-grid-summary right-align-cell${isSubtotal ? ' small-grid-summary' : ''}`}>
				<p>{renderGridSummarySumTonnes(data, 'td_returnsWeight')}</p>
			</div>

			<div className={`app-grid-summary right-align-cell${isSubtotal ? ' small-grid-summary' : ''}`}>
				<p>{renderGridSummarySum(data, 'td_ordersCount')}</p>
			</div>
		</>
	)
}

export default GridSummary;